// oxlint-disable no-unused-vars
/* eslint-disable
    consistent-return,
    no-shadow,
    one-var
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS201: Simplify complex destructure assignments
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import $ from 'jquery';
import _ from 'underscore';

import {assert} from 'Asserts';
import * as primerPlugin1 from 'assembly/_primer-plugin';

const {findJunctionAtPosition, primerPlugin, replacePrimerRegion} = primerPlugin1;

import * as shared from 'assembly/_shared';

const {addPrimerNameSuffixes, validSpacerOrder} = shared;

import * as biojs from 'BioJS';
import {NucleotideType, DNA_COMPLEMENT_TABLE} from 'biojs/BioConstants';
import * as util from 'biojs/Util';
import * as AssemblyConstants from 'constants/AssemblyConstants';

const {ASSEMBLY_TYPE} = AssemblyConstants;

import * as colors from 'lib/Colors';
import preferences from 'Preferences';
import * as sequtil from 'molbio/SeqUtil';
import {PrimerPreferences} from 'constants/PrimerConstants';

// primer binds to the downstream.
function gibsonPrimerDesign(upstream, downstream, opts) {
  // using the design algorithm described by
  // http://django.gibthon.org/help/primer/
  //
  // this function works on raw base inputs
  // and returns the 5'-3' primer required to give the DOWNSTREAM
  // sequence the correct overhang to connect to the UPSTREAM

  if (opts == null) {
    opts = {};
  }
  let flap = '';
  let base = '';

  if (
    downstream.length < opts.minOverlap ||
    upstream.length < opts.minOverlap ||
    opts.maxOverlap < opts.minOverlap
  ) {
    return [];
  }

  const maxDownstream = Math.min(downstream.length, opts.maxOverlap);
  const maxUpstream = Math.min(upstream.length, opts.maxOverlap);
  return _.chain(__range__(opts.minOverlap, maxDownstream + 1, false))
    .map((i) => {
      base = downstream.slice(0, i);
      const bindingTm = util.meltingTemperature(base, NucleotideType.DNA);
      if (bindingTm < opts.tmAnneal) {
        return [];
      }
      return _.chain(__range__(opts.minOverlap, maxUpstream + 1, false))
        .map((j) => {
          flap = upstream.slice(upstream.length - j);
          const primer = flap + base;
          if (util.meltingTemperature(primer, NucleotideType.DNA) >= opts.tmWhole) {
            return {
              bases: primer,
              bindingTm,
              down_overlap: base.length,
            };
          }
          return null;
        })
        .without(null)
        .value();
    })
    .flatten(true)
    .sortBy((primer) => primer.bases.length)
    .value();
}

function _getOverlapForDesign(overlap, spacer, spacerIsOverlap) {
  // For Gibson primer design, the spacer is added to the upstream input. So the `overlap` input needs to be
  // updated based on whether the spacer counts as overlap. This directly affects the assembly primer's
  // overhang.
  //
  // upstream | spacer | downstream
  //              ^
  //     counts as overlap?
  //
  // If spacer counts as overlap, then just return the max since the spacer needs to be in the overhang.
  // Otherwise, if the spacer doesn't count as overlap, then return the sum since both the spacer and actual
  // overlap need to be in the overhang.
  if (spacerIsOverlap) {
    return Math.max(spacer.length, overlap);
  }
  return spacer.length + overlap;
}

function designGibson(fragments, spacers, opts) {
  let fragment, junction5, junction3;
  // eslint-disable-next-line no-restricted-syntax
  const revcompFragments = _.map(fragments, (fragment) => fragment.cloneReverseComplement());

  // eslint-disable-next-line no-restricted-syntax
  const primerPairs = _.map(__range__(0, fragments.length, false), (i) => {
    const nextIndex = (i + 1) % fragments.length;
    const prevIndex = i === 0 ? fragments.length - 1 : i - 1;
    const forwardSpacer = (spacers[prevIndex] != null ? spacers[prevIndex].bases() : undefined) || '';
    const forwardSpacerIsOverlap = !fragments[prevIndex].has('_cutter3');
    // eslint-disable-next-line no-restricted-syntax
    const forwardOpts = _.extend({}, opts, {
      minOverlap: _getOverlapForDesign(opts.minOverlap, forwardSpacer, forwardSpacerIsOverlap),
      maxOverlap: _getOverlapForDesign(opts.maxOverlap, forwardSpacer, forwardSpacerIsOverlap),
    });
    const forwardPrimers = gibsonPrimerDesign(
      fragments[prevIndex].bases() + forwardSpacer,
      fragments[i].bases(),
      forwardOpts
    );

    const reverseSpacer = (spacers[i] != null ? spacers[i].bases() : undefined) || '';
    const reverseSpacerIsOverlap = !fragments[nextIndex].has('_cutter5');
    // eslint-disable-next-line no-restricted-syntax
    const reverseOpts = _.extend({}, opts, {
      minOverlap: _getOverlapForDesign(opts.minOverlap, reverseSpacer, reverseSpacerIsOverlap),
      maxOverlap: _getOverlapForDesign(opts.maxOverlap, reverseSpacer, reverseSpacerIsOverlap),
    });
    const reversePrimers = gibsonPrimerDesign(
      revcompFragments[nextIndex].bases() + util.revcomp(reverseSpacer, DNA_COMPLEMENT_TABLE),
      revcompFragments[i].bases(),
      reverseOpts
    );

    const validPrimers = [];
    for (const fwdPrimer of Array.from(forwardPrimers)) {
      for (const revPrimer of Array.from(reversePrimers)) {
        if (Math.abs(fwdPrimer.bindingTm - revPrimer.bindingTm) <= opts.tmDiff) {
          validPrimers.push([fwdPrimer, revPrimer]);
        }
      }
    }

    if (validPrimers.length === 0) {
      return null;
    }
    const best = _.min(validPrimers, (primers) => primers[0].bases.length + primers[1].bases.length);
    return {
      forward: best[0],
      reverse: best[1],
    };
  });

  for (const pair of Array.from(primerPairs)) {
    if (pair == null) {
      return;
    }
  }

  let _sequence = new biojs.Sequence();
  let junctions = (() => {
    let spacer;
    const result = [];
    for ([fragment, spacer] of Array.from(_.zip(fragments, spacers))) {
      junction5 = _sequence.length();
      _sequence = _sequence.concat(fragment);
      junction3 = _sequence.length();
      if (spacer != null) {
        _sequence = _sequence.concat(spacer);
      }
      result.push([junction5, junction3]);
    }
    return result;
  })();
  junctions = (() => {
    const result1 = [];
    for ([junction5, junction3] of Array.from(junctions)) {
      junction3 = sequtil.mod(junction3, _sequence.length());
      result1.push([junction5, junction3]);
    }
    return result1;
  })();
  _sequence.set({circular: true, junctions});

  const zipped = _.zip(
    primerPairs,
    fragments,
    junctions,
    colors.shuffledPastelColors.slice(0, fragments.length)
  );
  const sequencePrimers = _sequence.sequencePrimers();
  // eslint-disable-next-line no-restricted-syntax
  const pairIndices = _.map(zipped, ([pair, fragment, junction, color], i) => {
    if (fragment.has('_cutter5') && fragment.has('_cutter3')) {
      sequencePrimers.add({skip: true});
      sequencePrimers.add({skip: true});
      return null;
    }
    const {forward, reverse} = pair;
    [junction5, junction3] = Array.from(junction);
    sequencePrimers.add({
      bases: forward.bases,
      start: junction5,
      end: sequtil.mod(junction5 + forward.down_overlap, _sequence.length()),
      name: `${fragment.name()} FWD`,
      color,
      strand: 1,
    });
    sequencePrimers.add({
      bases: reverse.bases,
      start: sequtil.mod(junction3 - reverse.down_overlap, _sequence.length()),
      end: junction3,
      name: `${fragment.name()} REV`,
      color,
      strand: -1,
    });
    return {
      fwd_index: i * 2,
      rev_index: i * 2 + 1,
    };
  });
  addPrimerNameSuffixes(sequencePrimers);
  _sequence.set({primerPairs: pairIndices});
  return _sequence;
}

// eslint-disable-next-line no-restricted-syntax
const plugin = _.extend({}, primerPlugin, {
  assemblyType: ASSEMBLY_TYPE.GIBSON,

  attachTabs(sequence, buffer) {
    const GibsonTabState = require('assembly/tabs/GibsonTabState').default;
    buffer.add(new GibsonTabState({sequence}));
  },

  checkAssembly(assembly) {
    const errors = [];
    // eslint-disable-next-line no-restricted-syntax
    if (!_.every(assembly.slots().withoutSpacers(), (slot) => !slot.isEmpty())) {
      errors.push('A backbone or insert is unset.');
    }
    if (!validSpacerOrder(assembly.slots())) {
      errors.push('Spacer sequences must be adjacent to at least one fragment generated by PCR.');
    }
    return {errors, warnings: []};
  },

  _getTwoPrimerJunctionRanges(sequence, fwd, rev) {
    // Intersection of the two primers' ranges.
    return sequtil.getRangeOverlap(
      rev.start(),
      rev.overhangEdge(sequence),
      fwd.overhangEdge(sequence),
      fwd.end()
    );
  },

  _canInsert(sequence, selection, errback) {
    // Allow insert at junction only.
    const junction = findJunctionAtPosition(sequence, selection.modelStart());
    if (junction != null) {
      return true;
    } else {
      errback(`To insert bases outside junctions, \
finalize the sequence from the results tab.`);
      return false;
    }
  },

  canDelete(sequence, selection, errback) {
    if (sequence.finalized()) {
      return true;
    }
    const range = this._findDeleteRange(sequence, selection.modelStart(), selection.modelEnd());

    if (range != null) {
      return true;
    } else {
      errback(`To delete bases outside junction areas, \
finalize the sequence from the results tab.`);
      return false;
    }
  },

  didDelete(sequence, selection, deletionLength, callback, errback) {
    let bases, overlap;
    if (sequence.finalized()) {
      return;
    }
    const selectionStart = selection.modelStart();
    const selectionEnd = sequtil.mod(selectionStart + deletionLength, sequence.length());

    // Update primers to match sequence after deleting.
    const junction = findJunctionAtPosition(sequence, selectionStart);
    assert(
      junction != null,
      `junction was null after a delete (start=${selectionStart}, \
deletionLength=${deletionLength})`
    );
    const [junction3, junction5, fwdPrimer, revPrimer] = Array.from(junction);

    function getOverlap(primer, offset) {
      const rangeStart = sequtil.mod(selectionStart - offset, sequence.length());
      const rangeEnd = sequtil.mod(selectionEnd - offset, sequence.length());
      const overlaps = sequtil.getRangeOverlap(rangeStart, rangeEnd, primer.start(), primer.end());
      if (overlaps.length > 0) {
        const [start, end] = Array.from(overlaps[0]);
        return sequtil.distance(start, end, sequence.length(), sequence.circular());
      }
      return 0;
    }

    if (fwdPrimer != null) {
      // Calculate bases, overlap with an offset of deletionLength, because the fwdPrimer's
      // binding position has already been updated post-delete at this point in the lifecycle.
      // It was shifted upstream by deletionLength, so we need to take that into account.
      bases = replacePrimerRegion(
        sequence,
        fwdPrimer,
        '',
        fwdPrimer.overhangEdge(sequence) + deletionLength,
        selectionStart,
        selectionEnd
      );
      overlap = getOverlap(fwdPrimer, deletionLength);
      const fwdStart = sequtil.mod(fwdPrimer.start() + overlap, sequence.length());
      fwdPrimer.set({bases, start: fwdStart});
    }

    if (revPrimer != null) {
      bases = replacePrimerRegion(
        sequence,
        revPrimer,
        '',
        revPrimer.overhangEdge(sequence),
        selectionEnd,
        selectionStart
      );
      overlap = getOverlap(revPrimer, 0);
      const revEnd = sequtil.mod(revPrimer.end() - overlap, sequence.length());
      revPrimer.set({bases, end: revEnd});
    }

    $.when(fwdPrimer != null ? fwdPrimer.save(null, {fileUpdate: true}) : undefined)
      .then(() => (revPrimer != null ? revPrimer.save(null, {fileUpdate: true}) : undefined))
      .done(() => callback('Successfully updated primers.'))
      .fail(() =>
        errback(`Error updating primers. \
One or more primers may not be in sync with the newly edited sequence.`)
      );
  },

  didInsert(sequence, insertPos, bases, callback, errback) {
    let newBases, primerBases;
    if (sequence.finalized()) {
      return;
    }
    const junction = findJunctionAtPosition(sequence, insertPos);
    assert(junction != null, 'didInsert found no junction even though canEditSelection passed');
    const [junction3, junction5, fwdPrimer, revPrimer] = Array.from(junction);
    if (!(fwdPrimer != null || revPrimer != null)) {
      return;
    }

    if (fwdPrimer != null) {
      primerBases = fwdPrimer.bases();
      // Forward primer has shifted by `bases.length` along the sequence, and we want to insert
      // bases into primer at position originally at insertPos, so shift insertPos to match.
      const fwdInsert = sequtil.distance(
        fwdPrimer.overhangEdge(),
        insertPos + bases.length,
        sequence.length(),
        sequence.circular()
      );
      assert(fwdInsert < primerBases.length, 'fwdInsert must be before end of primer');
      newBases = primerBases.slice(0, fwdInsert) + bases + primerBases.slice(fwdInsert);
      fwdPrimer.set({bases: newBases});
    }

    if (revPrimer != null) {
      primerBases = revPrimer.bases();
      const revBases = util.revcomp(bases, DNA_COMPLEMENT_TABLE);
      const revInsert = sequtil.distance(
        revPrimer.overhangEdge(),
        insertPos,
        sequence.length(),
        sequence.circular()
      );
      newBases = primerBases.slice(0, revInsert) + revBases + primerBases.slice(revInsert);
      revPrimer.set({bases: newBases});
    }

    $.when(fwdPrimer != null ? fwdPrimer.save(null, {fileUpdate: true}) : undefined)
      .then(() => (revPrimer != null ? revPrimer.save(null, {fileUpdate: true}) : undefined))
      .done(() => callback('Primers successfully updated.'))
      .fail(() => errback('Error updating primers.'));
  },

  didReplace(sequence, selection, bases, callback, errback) {
    let primerBases;
    if (sequence.finalized()) {
      return;
    }
    const range = this._findReplaceRange(sequence, selection);
    assert(range != null, 'didReplace found no range even though _canInitiateReplace was passed');
    const [start, end, fwdPrimer, revPrimer] = Array.from(range);
    if (!(fwdPrimer != null || revPrimer != null)) {
      return;
    }

    if (fwdPrimer != null) {
      primerBases = replacePrimerRegion(
        sequence,
        fwdPrimer,
        bases,
        fwdPrimer.overhangEdge(sequence),
        selection.modelStart(),
        selection.modelEnd()
      );
      fwdPrimer.set({bases: primerBases});
    }

    if (revPrimer != null) {
      primerBases = replacePrimerRegion(
        sequence,
        revPrimer,
        util.revcomp(bases, DNA_COMPLEMENT_TABLE),
        revPrimer.overhangEdge(sequence),
        selection.modelEnd(),
        selection.modelStart()
      );
      revPrimer.set({bases: primerBases});
    }

    $.when(fwdPrimer != null ? fwdPrimer.save(null, {fileUpdate: true}) : undefined)
      .then(() => (revPrimer != null ? revPrimer.save(null, {fileUpdate: true}) : undefined))
      .done(() => callback('Primers successfully updated.'))
      .fail(() => errback('Error updating primers.'));
  },
});

export {designGibson, plugin};

function __range__(left, right, inclusive) {
  const range = [];
  const ascending = left < right;
  const end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}
